import { AsyncPipe } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    inject
} from "@angular/core";
import { MessagePanelComponent } from "@components/message-panel/message-panel.component";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { IMessageModel, MessageSeverity } from "~app/common/components/message-panel/message-panel.models";
import { EntityType, RuleSeverityLevel, RuleValidationMessage } from "~app/common/services/cqs/models/rule-validation-message";
import { VirkeskopValidationService } from "../../services/validation/virkeskop-validation.service";

@Component({
    selector: "rask-virkeskop-validation-message",
    templateUrl: "./virkeskop-validation-message.component.html",
    styleUrls: ["./virkeskop-validation-message.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MessagePanelComponent,
        AsyncPipe
    ]
})
export class VirkeskopValidationMessageComponent implements OnInit {
    @Input() entityGuid?: string;
    @Input() entityType?: EntityType;
    @Input() messageId: string[];

    protected messages$: Observable<IMessageModel[]>;

    private readonly validationService = inject(VirkeskopValidationService);

    ngOnInit(): void {
        this.messages$ = this.validationService
            .filterVisibleMessages(this.messageId, this.entityType, this.entityGuid)
            .pipe(map((value) =>
                this.mapRuleMessages(value)));
    }

    private mapRuleMessages(ruleValidationMessages: RuleValidationMessage[]): IMessageModel[] {
        return ruleValidationMessages
            .map(message => ({
                severity: this.mapRuleSeverity(message.severity),
                message: message.message,
                anchor: ""
            }));
    }

    private mapRuleSeverity(severity: RuleSeverityLevel): MessageSeverity {
        switch(severity) {
            case RuleSeverityLevel.info:
                return MessageSeverity.Info;
            case RuleSeverityLevel.warning:
                return MessageSeverity.Warning;
            case RuleSeverityLevel.error:
                return MessageSeverity.Error;
            default:
                throw new Error(`MessageSeverityLevel för ${severity} finns inte`);
        }
    }
}
